import { render, staticRenderFns } from "./newsletters_section.vue?vue&type=template&id=4824c634&scoped=true"
import script from "./newsletters_section.vue?vue&type=script&lang=js"
export * from "./newsletters_section.vue?vue&type=script&lang=js"
import style0 from "./newsletters_section.vue?vue&type=style&index=0&id=4824c634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4824c634",
  null
  
)

export default component.exports